/* eslint-disable @typescript-eslint/consistent-type-imports */
import { useCallback } from 'react';
import { useLazyQueryInterop } from '@confluence/apollo-relay-interop';

import { LazyConfluenceSmartCreationModal } from './LazyConfluenceSmartCreationModal.ts';
import ConfluenceSmartCreationModalQuery, {
	ConfluenceSmartCreationModalQuery$data,
	ConfluenceSmartCreationModalQuery$variables,
} from './__generated__/ConfluenceSmartCreationModalQuery.graphql.ts';

export const usePreloadSmartCreationModal = () => {
	const [preloadSmartCreationModalQuery] = useLazyQueryInterop<
		ConfluenceSmartCreationModalQuery$data,
		ConfluenceSmartCreationModalQuery$variables
	>(ConfluenceSmartCreationModalQuery);

	return useCallback(() => {
		preloadSmartCreationModalQuery();
		void LazyConfluenceSmartCreationModal.preload();
	}, [preloadSmartCreationModalQuery]);
};
